'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkComponent = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _reactRouterDom = require('react-router-dom');

var _selectors = require('@bd/bdcore-data/build/Plans/selectors');

var _selectors2 = require('@bd/bdcore-data/build/Homes/selectors');

var _selectors3 = require('@bd/bdcore-data/build/Lots/selectors');

var _selectors4 = require('@bd/bdcore-data/build/Communities/selectors');

var _RouteCollection = require('./RouteCollection');

var _RouteCollection2 = _interopRequireDefault(_RouteCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NODE_ENV = process.env.NODE_ENV;

function active(link, match, path, qs) {
  if (link.activeExact === false) {
    return (0, _lodash.get)(match, 'url').indexOf(path) !== -1 ? ' active' : '';
  }

  return path === (0, _lodash.get)(match, 'url') && (window.location.search || '').replace(/^\?/, '') === (qs || '') ? ' active' : '';
}

/**
 * Link React component
 * Use in place of Link from `react-router-dom` to get a path using a name and parameters
 * @param {object} routeSwitch provided by react
 * @public
 *
 * @return {React.Component}
 */
var LinkComponent = function LinkComponent(link, _ref) {
  var store = _ref.store;

  var path = link.to;

  var state = store.getState();

  var activeExact = link.activeExact,
      name = link.name,
      params = link.params,
      match = link.match,
      keepParams = link.keepParams,
      hash = link.hash,
      plan = link.plan,
      home = link.home,
      lot = link.lot,
      community = link.community,
      query = link.query,
      location = link.location,
      history = link.history,
      staticContext = link.staticContext,
      props = (0, _objectWithoutProperties3.default)(link, ['activeExact', 'name', 'params', 'match', 'keepParams', 'hash', 'plan', 'home', 'lot', 'community', 'query', 'location', 'history', 'staticContext']);


  var qs = void 0;
  var useParams = params;

  if (plan && community && !params) {
    useParams = (0, _selectors.getPlanRouteProps)(plan, (0, _extends3.default)({}, state, { community: community }));
  } else if (plan && !params) {
    useParams = (0, _selectors.getPlanRouteProps)(plan, state);
  } else if (home && !params) {
    useParams = (0, _selectors2.getHomeRouteProps)(home, state);
  } else if (lot && !params) {
    useParams = (0, _selectors3.getLotRouteProps)(lot, state);
  } else if (community && !params) {
    useParams = (0, _selectors4.getCommunityRouteProps)(community, state);
  }

  if (query && (typeof query === 'undefined' ? 'undefined' : (0, _typeof3.default)(query)) === 'object') {
    qs = (0, _keys2.default)(query).map(function (key) {
      return key + '=' + ((0, _typeof3.default)(query[key]) === 'object' ? (0, _stringify2.default)(query[key]) : query[key]);
    }).join('&');
  }

  if (name !== undefined) {
    try {
      path = _RouteCollection2.default.getPath(name, useParams || (keepParams ? (0, _lodash.get)(match, 'params') : undefined));
    } catch (error) {
      if (error.message === 'PathNotFound') {
        if (_RouteCollection2.default.hasRoutes() && NODE_ENV !== 'production') {
          throw new Error('Path was not found by the name \'' + name + '\'' + ('' + (useParams === undefined ? '' : ' With Parameters: ' + (0, _keys2.default)(useParams).map(function (key) {
            return '(' + key + ': ' + useParams[key] + ')';
          }))));
        }
        return _react2.default.createElement(
          _reactRouterDom.Link,
          (0, _assign2.default)({ to: '/404' }, props, { className: link.className + ' ' + (path === (0, _lodash.get)(match, 'url') ? 'active' : '') }),
          link.children
        );
      }

      if (NODE_ENV !== 'production') {
        throw error;
      } else {
        return _react2.default.createElement(
          _reactRouterDom.Link,
          (0, _assign2.default)({ to: '/404' }, props, { className: link.className + ' ' + (path === (0, _lodash.get)(match, 'url') ? 'active' : '') }),
          link.children
        );
      }
    }
  }

  return _react2.default.createElement(
    _reactRouterDom.Link,
    (0, _assign2.default)({ to: '' + path + (qs ? '?' + qs : '') + (hash || '') }, props, { className: '' + (link.className || '') + active(link, match, path, qs) }),
    link.children
  );
};

exports.LinkComponent = LinkComponent;
LinkComponent.contextTypes = {
  store: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactRouterDom.withRouter)(LinkComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-named-routes/build/Link.js
// module id = 924
// module chunks = 0